/**
 * Form widget actions
 * Defined in FormActionType.java
 */

export default {
	SAVE_RECORD: 'save-record',
	NEW_RECORD: 'new-record',
	GO_TO_PAGE: 'go-to-page',
	CHANGE_WIDGET_STATE: 'change-widget-state',
	CHANGE_WIDGET_VALIDATION: 'change-widget-validation',
	SET_FIELD_VALUE: 'set-field-value',
	SEND_ALERT: 'send-alert'
}